class AipetProductManager {
  constructor() {
    this.state = {
      inputMax: 12,
      currentStep: 1,

      step1: {
        selectedIndex: null,
        models: []
      },

      step2: {
        plans: []
      },

      step3: {
        accessories: []
      },

      step4: {
        totalPrice: 0,
        shippingDate: 'Ships within 30 business days'
      },

      step1Items: [],
      step2Items: [],
      stepSelectEl: null
    };

    this.init();
  }

  init() {
    this._initModelsFromProduct();
    this._initPlansFromPlanProduct();
    this._initAccessoriesFromClothProducts();

    setTimeout(() => {
      this.bindEvents();
      this.unlockStep();
      // 默认选中第一个型号(index 0)，以便进入页面即展示折扣信息与积分标签。
      // 放在 unlockStep 之后：unlockStep 仍以"未选中"状态运行，底部浮动结算条保持隐藏，
      // 仅通过 handleModelSelect 触发型号选中态 + 折扣 banner + 积分标签(.selected class)。
      this.handleModelSelect(0);
    }, 100);
  }

  get currencySymbol() {
    return window.currencySymbol || 'CA$';
  }

  // ========== 初始化 ==========

  _initModelsFromProduct() {
    const variants = (window.productObj?.variants || []).filter(v => v.featured_image);
    this.state.step1.models = variants.map((v, i) => ({
      index: i,
      variantId: String(v.id),
      title: v.title,
      price: v.price / 100,
      image: i===0 ? 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/1.5x_a3ecef4f-f7b8-4717-976e-ab2fed4b2b7a.webp?v=1769138363' : 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/1.5x_1_6b653338-cea9-4ddf-9051-e40e4ee4b7c9.webp?v=1769138362',
      isSelected: false
    }));
    this.state.step1.models.push({
      index: this.state.step1.models.length,
      variantId: '',
      title: 'Not Selected',
      price: 0,
      image: 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/153_4x_2f0a837d-b566-406a-9655-07dea5a5b6c6.webp?v=1769418296',
      isSelected: false
    });
  }

  _initPlansFromPlanProduct() {
    const variants = window.PlanProdObj?.variants;
    if (!variants?.length) return;

    // variant order matches Liquid plan_variants:
    // [0] Essential Monthly  [1] Essential Annual
    // [2] Premium Annual     [3] One-Time
    const price = (i) => (variants[i]?.price || 0) / 100;
    const id    = (i) => variants[i] ? String(variants[i].id) : '';

    this.state.step2.plans = [
      {
        index: 0,
        name: 'Essential Plan',
        isSelected: false,
        quantity: 1,
        currentVariantId: id(0),
        variants: [
          { type: 'month', variantId: id(0), price: price(0), isActive: true  },
          { type: 'year',  variantId: id(1), price: price(1), isActive: false }
        ]
      },
      {
        index: 1,
        name: 'Premium Plan (Annual)',
        isSelected: false,
        quantity: 1,
        currentVariantId: id(2),
        variants: [
          { type: 'yearService', variantId: id(2), price: price(2), isActive: true }
        ]
      },
      {
        index: 2,
        name: 'One-Time Purchase Plan',
        isSelected: false,
        quantity: 1,
        currentVariantId: id(3),
        variants: [
          { type: 'all', variantId: id(3), price: price(3), isActive: true }
        ]
      },
      {
        index: 3,
        name: 'Not Selected',
        isSelected: false,
        quantity: 1,
        currentVariantId: '',
        variants: [{ type: 'none', variantId: '', price: 0, isActive: true }]
      }
    ];
  }

  _initAccessoriesFromClothProducts() {
    const clothProds = window.ClothProdObjs;
    if (!clothProds?.length) return;
    this.state.step3.accessories = clothProds.map((prod, index) => {
      const variant = prod?.variants?.[0];
      return {
        index,
        variantId: variant ? String(variant.id) : '',
        title: prod?.title || '',
        price: variant ? (variant.price / 100) : 0,
        quantity: 1,
        isSelected: false
      };
    });
  }

  // ========== 事件绑定 ==========

  bindEvents() {
    const modelItems = document.querySelectorAll('#aipetProductStep1_Main .aipet-product-step1-item');
    this.state.step1Items = modelItems || [];

    modelItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.aipet-product-step1-item-img-searchicon')) return;
        this.handleModelSelect(index);
      });
    });

    const step1NextBtn = document.querySelector('#aipetProductStep1_Main .aipet-product-step1-next');
    step1NextBtn && step1NextBtn.addEventListener('click', () => {
      if (!this.state.step1.models.some(m => m.isSelected)) return;
      this.state.currentStep = 2;
      this.unlockStep();
    });

    const step1ViewCards = document.querySelectorAll('#aipetProductStep1_Main .aipet-product-step1-item-img-searchicon');
    step1ViewCards.forEach(imgEl => {
      imgEl.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        myAipetDialogImgClick(imgEl.dataset.type);
      });
    });

    const planItems = document.querySelectorAll('#aipetProductStep2_Plan .aipet-product-step2-item');
    this.state.step2Items = planItems || [];
    planItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.aipet-product-step2-item-middle-num') ||
            e.target.closest('.aipet-product-step2-item-middle-top-right')) return;
        this.handlePlanSelect(index);
      });
    });

    const typeButtons = document.querySelectorAll('.aipet-product-step2-item-middle-top-right > div');
    typeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handlePlanTypeChange(btn);
      });
    });

    const quantityButtons = document.querySelectorAll('.aipet-product-step2-item-middle-num-plus, .aipet-product-step2-item-middle-num-minus');
    quantityButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const action = btn.classList.contains('aipet-product-step2-item-middle-num-plus') ? 'plus' : 'minus';
        const inputId = btn.parentElement.querySelector('input')?.id;
        if (inputId) {
          const planIndex = parseInt(inputId.match(/\d+$/)?.[0]);
          if (!isNaN(planIndex)) this.handleQuantityChange(planIndex, action);
        }
      });
    });

    const step2Inputs = document.querySelectorAll('.aipet-product-step2-item-middle-num-input');
    step2Inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const inputId = e.target.id;
        const planIndex = parseInt(inputId.match(/\d+$/)?.[0]);
        if (!isNaN(planIndex)) {
          let value = Math.min(Math.max(parseInt(e.target.value) || 1, 1), this.state.inputMax);
          e.target.value = value;
          this.state.step2.plans[planIndex].quantity = value;
          this.updatePlanTotal(planIndex);
          this.calculateTotal();
          this.updateCheckoutContent();
          this.updateStepSummary();
        }
      });
    });

    const step2NextBtn = document.querySelector('#aipetProductStep2_Plan .aipet-product-step2-next');
    if (step2NextBtn) {
      step2NextBtn.addEventListener('click', () => {
        if (!this.state.step2.plans.some(p => p.isSelected)) return;
        this.state.currentStep = 3;
        this.unlockStep();
      });
    }

    this.state.stepSelectEl = document.getElementById('aipetProductStep_Select');

    // ========== Step 3: 配件选择 ==========
    const accessoryItems = document.querySelectorAll('#aipetProductStep3_Cloth .aipet-product-step3-item');
    accessoryItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.aipet-product-step3-item-img-searchicon')) return;
        const accessory = this.state.step3.accessories[index];
        if (!accessory) return;
        accessory.isSelected = !accessory.isSelected;
        item.classList.toggle('selected', accessory.isSelected);
        this.calculateTotal();
        this.updateCheckoutContent();
        this.updateStepSummary();
        const step3Btn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-btn');
        if (step3Btn) {
          const anySelected = this.state.step3.accessories.some(acc => acc.isSelected);
          step3Btn.textContent = anySelected ? 'Confirm and Proceed' : 'Skip Accessories';
        }
      });
    });

    const step3ViewCards = document.querySelectorAll('#aipetProductStep3_Cloth .aipet-product-step3-item-img-searchicon');
    step3ViewCards.forEach(imgEl => {
      imgEl.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        openClothDialog(imgEl.dataset.type);
      });
    });

    const step3NextBtn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-btn');
    if (step3NextBtn) {
      step3NextBtn.addEventListener('click', () => {
        if (!this.isCanShowCheckout()) {
          this.showCannotCheckoutDialog(true);
          return;
        }
        this.state.currentStep = 4;
        this.unlockStep();
      });
    }

    // Step 3 carousel prev/next
    const step3ClothContent = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step-content.cloth-content');
    const step3PrevBtn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-prev');
    const step3NextNavBtn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-next');
    const updateStep3NavBtns = () => {
      if (!step3ClothContent) return;
      const atLeft = step3ClothContent.scrollLeft <= 0;
      const atRight = step3ClothContent.scrollLeft >= step3ClothContent.scrollWidth - step3ClothContent.clientWidth - 1;
      if (step3PrevBtn) step3PrevBtn.style.opacity = atLeft ? '0.3' : '1';
      if (step3NextNavBtn) step3NextNavBtn.style.opacity = atRight ? '0.3' : '1';
    };
    if (step3PrevBtn && step3ClothContent) {
      step3PrevBtn.addEventListener('click', () => {
        if (step3ClothContent.scrollLeft <= 0) return;
        const itemWidth = step3ClothContent.querySelector('.aipet-product-step3-item')?.offsetWidth || 0;
        step3ClothContent.scrollLeft -= itemWidth + 6;
        setTimeout(updateStep3NavBtns, 350);
      });
    }
    if (step3NextNavBtn && step3ClothContent) {
      step3NextNavBtn.addEventListener('click', () => {
        const maxScroll = step3ClothContent.scrollWidth - step3ClothContent.clientWidth;
        if (step3ClothContent.scrollLeft >= maxScroll) return;
        const itemWidth = step3ClothContent.querySelector('.aipet-product-step3-item')?.offsetWidth || 0;
        step3ClothContent.scrollLeft += itemWidth + 6;
        setTimeout(updateStep3NavBtns, 350);
      });
    }
    if (step3ClothContent) {
      step3ClothContent.addEventListener('scroll', updateStep3NavBtns);
      updateStep3NavBtns();
    }

    const cannotCheckoutCloseBtn = document.querySelector('.aipet-product-cannotcheckout-dialog-close');
    if (cannotCheckoutCloseBtn) {
      cannotCheckoutCloseBtn.addEventListener('click', () => this.showCannotCheckoutDialog(false));
    }

    const addToCartBtn = document.getElementById('myAipetAddToCartBtnId');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => this.addToCart());
    }

    this.initStep4Observer();
  }

  // ========== Step 1: 模型选择 ==========

  handleModelSelect(index) {
    const model = this.state.step1.models[index];
    if (!model) return;

    this.state.step1.models.forEach((m, i) => { m.isSelected = i === index; });
    this.state.step1.selectedIndex = index;

    this.state.step1Items.forEach((item, i) => {
      item.classList.toggle('selected', i === index);
    });

    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();

    // 折扣 banner 跟随选中的型号变体刷新（无变体的"Plan Only"会被自动隐藏）
    this.updateDiscountBanner(model.variantId);

    if (model.variantId) {
      MyCustomProductSliderConstructor.myProdSliderVariantForImg(model.variantId);
    }
  }

  // ========== 折扣 banner（Select Your Model 区域）==========
  // 数据源：window.myProdDCConfigCustomObj（shop metafield，按 productId -> variantId 索引）
  // 基准价取自 window.productObj 对应变体（单位:分），折后价 = 基准价 × 折扣
  updateDiscountBanner(variantId) {
    const wrap = document.getElementById('myProudcetAddBanner');
    if (!wrap) return;
    const hide = () => { wrap.style.display = 'none'; };

    const vid = String(variantId || '').trim();
    if (!vid) { hide(); return; } // "Plan Only" 等无型号变体：隐藏

    const dcConfig = window.myProdDCConfigCustomObj || {};
    const prodConfig = dcConfig[window.productId] || dcConfig[String(window.productId)] || {};
    const info = prodConfig[vid];
    if (!info || !info.disCountcode) { hide(); return; } // 该变体无折扣配置：隐藏

    const variant = (window.productObj?.variants || []).find(v => String(v.id) === vid);
    if (!variant) { hide(); return; }
    const basePrice = variant.price / 100;

    const setText = (sel, text) => {
      document.querySelectorAll(sel).forEach(el => { el.textContent = text; });
    };
    setText('.js-banner-num', info.disCountoff);
    setText('.js-banner-code', info.disCountcode);
    const descEl = document.getElementById('myProductBannerDescCWrapId');
    if (descEl) descEl.textContent = info.desc || '';

    const offNum = parseFloat(String(info.disCountoff || '').replace(/[^\d.]/g, ''));
    let discounted = basePrice;
    if (!isNaN(offNum)) {
      discounted = info.disCountType === 'money' ? basePrice - offNum : basePrice * (1 - offNum / 100);
    }
    if (discounted < 0) discounted = 0;
    // 折后价向上取整到分，容差仅用于消除浮点运算尾差。
    const discountedCents = discounted * 100;
    const roundingTolerance = Number.EPSILON * Math.max(1, variant.price) * 4;
    discounted = Math.max(0, Math.ceil(discountedCents - roundingTolerance)) / 100;
    const priceText = this.currencySymbol + discounted.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    setText('.js-banner-price', priceText);

    wrap.style.display = 'block';
  }

  // ========== Step 2: 套餐选择 ==========

  handlePlanSelect(index) {
    const plan = this.state.step2.plans[index];
    if (!plan) return;

    const activeVariant = plan.variants.find(v => v.isActive);
    if (activeVariant) plan.currentVariantId = activeVariant.variantId;

    this.state.step2Items.forEach((item, i) => {
      const isSelected = i === index;
      item.classList.toggle('selected', isSelected);
      this.state.step2.plans[i].isSelected = isSelected;
    });

    this.restorePlanUI(index);
    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();
  }

  restorePlanUI(index) {
    const planItems = document.querySelectorAll('#aipetProductStep2_Plan .aipet-product-step2-item');
    const planItem = planItems[index];
    if (!planItem) return;

    const plan = this.state.step2.plans[index];
    const input = planItem.querySelector(`#aipet-product-step2-item-input${index}`);
    if (input) input.value = plan.quantity;

    if (plan.variants.length > 1) {
      const activeVariant = plan.variants.find(v => v.isActive);
      if (activeVariant) {
        const monthBtn = planItem.querySelector('.aipet-product-step2-item-middle-top-right-month');
        const yearBtn  = planItem.querySelector('.aipet-product-step2-item-middle-top-right-year');
        const isMonth = activeVariant.type === 'month';
        monthBtn?.classList.toggle('active', isMonth);
        yearBtn?.classList.toggle('active', !isMonth);

        const priceEl = planItem.querySelector('.aipet-product-step2-item-middle-price');
        if (priceEl) {
          priceEl.textContent = `${this.currencySymbol}${activeVariant.price.toLocaleString()} / ${this._getPriceUnit(activeVariant.type)}`;
        }
      }
    }

    this.updatePlanTotal(index);
  }

  handlePlanTypeChange(btn) {
    const planItem = btn.closest('.aipet-product-step2-item');
    const planIndex = Array.from(planItem.parentElement.children).indexOf(planItem);
    const plan = this.state.step2.plans[planIndex];
    if (!plan || plan.variants.length <= 1) return;

    const isMonth = btn.classList.contains('aipet-product-step2-item-middle-top-right-month');
    const targetType = isMonth ? 'month' : 'year';

    plan.variants.forEach(variant => {
      variant.isActive = variant.type === targetType;
      if (variant.isActive) plan.currentVariantId = variant.variantId;
    });

    const monthBtn = planItem.querySelector('.aipet-product-step2-item-middle-top-right-month');
    const yearBtn  = planItem.querySelector('.aipet-product-step2-item-middle-top-right-year');
    monthBtn?.classList.toggle('active', isMonth);
    yearBtn?.classList.toggle('active', !isMonth);

    const activeVariant = plan.variants.find(v => v.isActive);
    if (activeVariant) {
      const priceEl = planItem.querySelector('.aipet-product-step2-item-middle-price');
      if (priceEl) {
        priceEl.textContent = `${this.currencySymbol}${activeVariant.price.toLocaleString()} / ${this._getPriceUnit(activeVariant.type)}`;
      }
    }

    this.updatePlanTotal(planIndex);
    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();
  }

  handleQuantityChange(planIndex, action) {
    const plan = this.state.step2.plans[planIndex];
    if (!plan) return;

    const input = document.querySelector(`#aipet-product-step2-item-input${planIndex}`);
    let value = parseInt(input?.value) || 1;

    if (action === 'plus' && value < this.state.inputMax) value++;
    else if (action === 'minus' && value > 1) value--;

    if (input) input.value = value;
    plan.quantity = value;

    this.updatePlanTotal(planIndex);
    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();
  }

  updatePlanTotal(planIndex) {
    const plan = this.state.step2.plans[planIndex];
    const activeVariant = plan.variants.find(v => v.isActive);
    if (!activeVariant) return;

    const planItems = document.querySelectorAll('#aipetProductStep2_Plan .aipet-product-step2-item');
    const hjElement = planItems[planIndex]?.querySelector('.aipet-product-step2-item-middle-num-hj');
    if (!hjElement) return;

    if (plan.quantity >= 1) {
      const isYearly = activeVariant.type === 'year' || activeVariant.type === 'yearService';
      const monthNum = isYearly ? plan.quantity * 12 : plan.quantity;
      const totalPrice = activeVariant.price * plan.quantity;
      hjElement.textContent = `Total(${monthNum} months): ${this.currencySymbol}${totalPrice.toLocaleString()}`;
    } else {
      hjElement.textContent = '';
    }
  }

  // ========== 计算总价 ==========

  calculateTotal() {
    let total = 0;

    if (this.state.step1.selectedIndex !== null) {
      const selectedModel = this.state.step1.models[this.state.step1.selectedIndex];
      if (selectedModel) total += selectedModel.price;
    }

    this.state.step2.plans.forEach(plan => {
      if (plan.isSelected) {
        const activeVariant = plan.variants.find(v => v.isActive);
        if (activeVariant) total += activeVariant.price * plan.quantity;
      }
    });

    this.state.step3.accessories.forEach(accessory => {
      if (accessory.isSelected) total += accessory.price * accessory.quantity;
    });

    this.state.step4.totalPrice = total;
  }

  // ========== 步骤控制 ==========

  unlockStep() {
    const stepIds = [
      'aipetProductStep1_Main',
      'aipetProductStep2_Plan',
      'aipetProductStep3_Cloth',
      'aipetProductStep4_Overview'
    ];
    const stepNumber = this.state.currentStep;
    const currentStepEl = document.getElementById(stepIds[stepNumber - 1]);
    currentStepEl.classList.remove('aipet-product-step-mask');
    currentStepEl.classList.add('active');

    for (let i = stepNumber; i < stepIds.length; i++) {
      const el = document.getElementById(stepIds[i]);
      el && el.classList.add('aipet-product-step-mask');
      el && el.classList.remove('active');
    }

    if (this.state.stepSelectEl && this.state.step1.selectedIndex !== null) {
      this.state.stepSelectEl.classList.add('show');
    }

    this.updateStepIndicators();

    // 进入页面(step1)时不再自动滚动，避免刚进入就自动下滚一点；仅在切换到 step2/step4 时滚动。
    // 原逻辑（会导致进入页面即自动下滚）已注释保留，如需恢复删掉下面判断、放开此行即可：
    // setTimeout(() => this.scrollToStepElement(currentStepEl), 200);
    if (this.state.currentStep > 1) {
      setTimeout(() => this.scrollToStepElement(currentStepEl), 200);
    }
  }

  updateStepSummary() {
    if (!this.state.stepSelectEl) return;

    const step1 = this.state.step1.models.find(m => m.isSelected);
    if (step1?.title) {
      const leftImg = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-left img');
      const titleEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-left .aipet-product-step-selectwrap-left-title');
      if (leftImg) leftImg.src = step1.image;
      if (titleEl) titleEl.textContent = step1.title;
    }

    const step2 = this.state.step2.plans.find(p => p.isSelected);
    if (step2?.name) {
      const planEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-middle .aipet-product-step-selectwrap-select2');
      if (planEl) {
        planEl.textContent = step2.currentVariantId
          ? `${step2.name} x ${step2.quantity}`
          : step2.name;
      }
    }

    const step3Items = this.state.step3.accessories
      .filter(a => a.isSelected)
      .map(a => a.title);
    const accEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-middle .aipet-product-step-selectwrap-select3');
    if (accEl) accEl.textContent = step3Items.length > 0 ? step3Items.join(' + ') : '';

    const hjPriceEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-right .aipet-product-step-selectwrap-hj-price');
    if (hjPriceEl) {
      hjPriceEl.textContent = `${this.currencySymbol}${this.state.step4.totalPrice.toLocaleString()}`;
    }

    const psDateStr = getMyProductEstimatedStrFn();
    const estDateEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-ps-date');
    if (estDateEl) {
      estDateEl.textContent = psDateStr || 'Ships within 30 business days';
    }

    this.updateStepIndicators();
  }

  updateStepIndicators() {
    const steps = document.querySelectorAll('.aipet-product-step-selectwrap-stepswrap > div');
    steps.forEach((step, index) => {
      step.classList.toggle('active', index < this.state.currentStep - 1);
    });
  }

  updateCheckoutContent() {
    const checkoutEle = document.getElementById('aipetProductStep4_Overview');
    if (!checkoutEle) return;

    const step1 = this.state.step1.models.find(m => m.isSelected);
    if (step1?.title) {
      const leftImg = checkoutEle.querySelector('.aipet-product-step4-selectitem.pet > .aipet-product-step4-selectitem-left img');
      const titleEl = checkoutEle.querySelector('.aipet-product-step4-selectitem.pet .aipet-product-step4-selectitem-title');
      const priceEl = checkoutEle.querySelector('.aipet-product-step4-selectitem.pet .aipet-product-step4-selectitem-price');
      if (leftImg) leftImg.src = step1.image;
      if (titleEl) titleEl.textContent = step1.title;
      if (priceEl) priceEl.textContent = `${this.currencySymbol}${step1.price.toLocaleString()}`;
    }

    const step2 = this.state.step2.plans.find(p => p.isSelected);
    if (step2?.name) {
      const leftEl  = checkoutEle.querySelector('.aipet-product-step4-selectitem.plan > .aipet-product-step4-selectitem-left');
      const rightEl = checkoutEle.querySelector('.aipet-product-step4-selectitem.plan > .aipet-product-step4-selectitem-right');
      if (leftEl) leftEl.textContent = step2.name;
      if (rightEl) {
        const activeVariant = step2.variants.find(v => v.isActive);
        if (activeVariant) {
          const allPrice = activeVariant.price * step2.quantity;
          const unit = this._getPriceUnit(activeVariant.type);
          rightEl.textContent = unit
            ? `${this.currencySymbol}${allPrice.toLocaleString()} / ${step2.quantity}${unit}`
            : `${this.currencySymbol}${allPrice.toLocaleString()}`;
        }
      }
    }

    // 清空配件区域并按需渲染
    const clothEl = checkoutEle.querySelector('.aipet-product-step4-selectitem-cloth');
    if (clothEl) {
      const selected = this.state.step3.accessories.filter(a => a.isSelected);
      if (selected.length > 0) {
        clothEl.innerHTML = selected.map(a => `
          <div class="aipet-product-step4-selectitem cloth">
            <div class="aipet-product-step4-selectitem-left">${a.title}</div>
            <div class="aipet-product-step4-selectitem-right">${this.currencySymbol}${(a.price * a.quantity).toLocaleString()}</div>
          </div>
        `).join('');
      } else {
        clothEl.innerHTML = '';
      }
    }

    const hjPriceEl = checkoutEle.querySelector('.aipet-product-step4-select-hj-price');
    if (hjPriceEl) {
      hjPriceEl.textContent = `${this.currencySymbol}${this.state.step4.totalPrice.toLocaleString()}`;
    }

    const checkoutBtn = checkoutEle.querySelector('.aipet-product-checkout-btn > a');
    if (checkoutBtn) {
      const items = [];
      if (this.state.step1.selectedIndex !== null) {
        const selectedModel = this.state.step1.models[this.state.step1.selectedIndex];
        if (selectedModel?.variantId) items.push(`${selectedModel.variantId}:1`);
      }
      this.state.step2.plans.forEach(plan => {
        if (plan.isSelected && plan.currentVariantId) {
          items.push(`${plan.currentVariantId}:${plan.quantity}`);
        }
      });
      this.state.step3.accessories.forEach(accessory => {
        if (accessory.isSelected && accessory.variantId && accessory.quantity > 0) {
          items.push(`${accessory.variantId}:${accessory.quantity}`);
        }
      });
      checkoutBtn.href = items.length > 0 ? `/cart/${items.join(',')}` : '#';
    }

    const psDateStr = getMyProductEstimatedStrFn();
    const estDateEl = checkoutEle.querySelector('.aipet-product-step4-select-ps-date');
    if (estDateEl) {
      estDateEl.textContent = psDateStr || 'Ships within 30 business days';
    }
  }

  scrollToStepElement(stepElement) {
    if (!stepElement) return;
    const offset = 20;
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const elementTop = stepElement.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: Math.max(0, elementTop - headerHeight - offset), behavior: 'smooth' });
  }

  initStep4Observer() {
    const step4 = document.getElementById('aipetProductStep4_Overview');
    if (!step4 || !this.state.stepSelectEl) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const step4HasMask = step4.classList.contains('aipet-product-step-mask');
        if (entry.isIntersecting) {
          if (step4HasMask && this.state.currentStep > 1) {
            this.state.stepSelectEl.classList.add('show');
            this.state.stepSelectEl.classList.remove('hide');
          } else if (!step4HasMask) {
            this.state.stepSelectEl.classList.remove('show');
            this.state.stepSelectEl.classList.add('hide');
          }
        } else if (this.state.currentStep > 1) {
          this.state.stepSelectEl.classList.add('show');
          this.state.stepSelectEl.classList.remove('hide');
        }
      });
    }, { threshold: 0.1, rootMargin: '-50px 0px -50px 0px' });

    observer.observe(step4);
  }

  isCanShowCheckout() {
    return this.state.step1.models.some(m => m.isSelected && m.variantId)
        || this.state.step2.plans.some(p => p.isSelected && p.currentVariantId);
  }

  showCannotCheckoutDialog(show) {
    document.querySelector('.aipet-product-cannotcheckout-dialog')?.classList.toggle('active', show);
  }

  // ========== 加入购物车 ==========

  async addToCart() {
    if (!this.isCanShowCheckout()) {
      this.showCannotCheckoutDialog(true);
      return;
    }

    const items = [];

    // Model
    if (this.state.step1.selectedIndex !== null) {
      const model = this.state.step1.models[this.state.step1.selectedIndex];
      if (model?.variantId) items.push({ id: parseInt(model.variantId), quantity: 1 });
    }

    // Plan
    this.state.step2.plans.forEach(plan => {
      if (plan.isSelected && plan.currentVariantId) {
        items.push({ id: parseInt(plan.currentVariantId), quantity: plan.quantity });
      }
    });

    // Accessories (Step 3)
    this.state.step3.accessories.forEach(accessory => {
      if (accessory.isSelected && accessory.variantId && accessory.quantity > 0) {
        items.push({ id: parseInt(accessory.variantId), quantity: accessory.quantity });
      }
    });

    if (items.length === 0) {
      this.showCannotCheckoutDialog(true);
      return;
    }

    const btn = document.getElementById('myAipetAddToCartBtnId');
    if (btn) btn.classList.add('loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('add failed');
    } catch {
      if (btn) btn.classList.remove('loading');
    }
  }

  // ========== 工具方法 ==========

  _getPriceUnit(type) {
    if (type === 'month') return 'Month';
    if (type === 'year' || type === 'yearService') return 'Year';
    return '';
  }
}

// ========== 初始化 ==========

let aipetManager;

function initAipetManager() {
  aipetManager = new AipetProductManager();
  window.aipetManager = aipetManager;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAipetManager);
} else {
  initAipetManager();
}


/* 弹窗图片 */
const aipetGBObj = { isMbUI: false };

const myAipetDialogImgClick = (type) => {
  if (!type) return;
  myAipetDialogImgClose(true);

  const imgMap = {
    plan:       [
      'https://cdn.shopify.com/s/files/1/0335/7333/9269/files/3_af0c39b9-4d6b-463a-be96-ef74980a779e.png?v=1778552401',
      'https://cdn.shopify.com/s/files/1/0335/7333/9269/files/2_17e7c8d1-9714-4836-b716-a08fa33f6543.png?v=1778552402'
    ],
    compare:    [
      'https://cdn.shopify.com/s/files/1/0335/7333/9269/files/1_dd0f254f-3c9d-454a-bc87-bb40e7c2dfa8.png?v=1778552401',
      'https://cdn.shopify.com/s/files/1/0564/9494/8417/files/0.75x_1.png?v=1778566381'
    ],
    card_niko:  [
      'https://cdn.shopify.com/s/files/1/0335/7333/9269/files/M_3x_d6db5018-8966-4a69-90d2-b651acf58424.webp?v=1778474012',
      'https://cdn.shopify.com/s/files/1/0335/7333/9269/files/Niko_1.5x.webp?v=1778143358'
    ],
    card_noa:   [
      'https://cdn.shopify.com/s/files/1/0335/7333/9269/files/M_3x_9abea762-5646-4ba8-baf3-5c722d454049.webp?v=1778474015',
      'https://cdn.shopify.com/s/files/1/0335/7333/9269/files/Noa_1.5x.webp?v=1778143359'
    ],
    setp2_free: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/4255_3x_1.webp?v=1770286484',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/4401_2x_be350cac-13c5-49f9-9cb4-4bed37a47edb.webp?v=1770286483'
    ]
  };

  const urls = imgMap[type];
  if (urls) {
    const src = aipetGBObj.isMbUI ? urls[0] : urls[1];
    $('#myCustomAipetDilaogImg').attr('src', src);
  }
};

const myAipetDialogImgClose = (flag) => {
  $('.aipet-product-dialog-imgwrap').toggleClass('active', !!flag);
};


// 获取预计发货日期
function getMyProductEstimatedStrFn() {
  const now = new Date();
  const day = now.getDay() || 7;
  const daysUntilMonday = day >= 5 ? 8 - day : 1;
  const target = new Date(now);
  target.setDate(target.getDate() + daysUntilMonday);
  const yy = target.getFullYear();
  const mm = String(target.getMonth() + 1).padStart(2, '0');
  const dd = String(target.getDate()).padStart(2, '0');
  return `${yy}/${mm}/${dd}`;
}

function myCustomInit() {
  aipetGBObj.isMbUI = window.screen.width <= 767;
  if (aipetGBObj.isMbUI) {
    document.querySelector('.aipet-product-content-infowrap-pcshow').innerHTML = '';
  } else {
    document.querySelector('.aipet-product-content-infowrap-mbshow').innerHTML = '';
  }
}
document.addEventListener('DOMContentLoaded', myCustomInit);

/* 第三步配件放大镜弹窗 & 轮播 */
const clothImagesData = {
  cloth_0: {
    noa: [
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-3.jpg?v=1779415991',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-4.jpg?v=1779415990',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-5.jpg?v=1779415991',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-6.jpg?v=1779415990'
    ],
    niko: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-1.jpg?v=1779415945',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-2.jpg?v=1779415966'
    ],
    all: [
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-3.jpg?v=1779415991',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-4.jpg?v=1779415990',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-5.jpg?v=1779415991',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-6.jpg?v=1779415990',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-1.jpg?v=1779415945',
      'https://www.switch-bot.com/cdn/shop/files/KATA_Friends_-_-1500X1500-2.jpg?v=1779415966'
    ]
  },
  cloth_1: {
    noa: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-1_2049a934-b5b1-4b06-aa8f-caacdc5aff74.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-2.jpg?v=1779416989'
    ],
    niko: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-3.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-4.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-5.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-6.jpg?v=1779416989'
    ],
    all: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-1_2049a934-b5b1-4b06-aa8f-caacdc5aff74.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-2.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-3.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-4.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-5.jpg?v=1779416989',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-6.jpg?v=1779416989'
    ]
  },
  cloth_3: {
    noa: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-1_96786e06-db8d-4d0b-a828-25275f1b472c.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-2_3554c4f4-6d95-4c70-8022-fd2b5017cbf5.jpg?v=1779417594'
    ],
    niko: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-4_6406e22e-583a-44f1-afb3-c4b99305595e.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-3_8e870adb-a318-4dde-8fcf-365b35d64f1f.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-5_40327d28-f415-472a-b2d4-43f1ebccd441.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-6_56b35625-d20b-4190-9e30-eadfbfcb086f.jpg?v=1779417594'
    ],
    all: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-1_96786e06-db8d-4d0b-a828-25275f1b472c.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-2_3554c4f4-6d95-4c70-8022-fd2b5017cbf5.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-4_6406e22e-583a-44f1-afb3-c4b99305595e.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-3_8e870adb-a318-4dde-8fcf-365b35d64f1f.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-5_40327d28-f415-472a-b2d4-43f1ebccd441.jpg?v=1779417594',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-_-1500X1500-6_56b35625-d20b-4190-9e30-eadfbfcb086f.jpg?v=1779417594'
    ]
  },
  cloth_4: {
    noa: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-3.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-4.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-5.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-6.jpg?v=1779417802'
    ],
    niko: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-1.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-2.jpg?v=1779417802'
    ],
    all: [
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-3.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-4.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-5.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-6.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-1.jpg?v=1779417802',
      'https://www.switch-bot.com/cdn/shop/files/KATAFriends_-1500X1500-2.jpg?v=1779417802'
    ]
  }
};

let clothSliderState = { currentIndex: 0, total: 0 };

function openClothDialog(type) {
  const data = clothImagesData[type];
  if (!data) return;

  const selectedModel = window.aipetManager?.state?.step1?.models?.find(m => m.isSelected);
  let images;
  if (selectedModel && !selectedModel.isPlanOnly) {
    if (selectedModel.index === 0) images = data.noa;
    else if (selectedModel.index === 1) images = data.niko;
    else images = data.all;
  } else {
    images = data.all;
  }
  if (!images?.length) return;

  const dialog = document.querySelector('.aipet-product-cloth-dialog');
  if (!dialog) return;

  const track = dialog.querySelector('.aipet-product-cloth-slider-track');
  const dotsEl = dialog.querySelector('.aipet-product-cloth-slider-dots');

  track.innerHTML = images.map(src =>
    `<div class="aipet-product-cloth-slider-item"><img src="${src}" alt="" loading="lazy" /></div>`
  ).join('');

  dotsEl.innerHTML = images.map((src, i) =>
    `<img class="aipet-product-cloth-slider-dot${i === 0 ? ' active' : ''}" src="${src}" data-index="${i}" alt="" loading="lazy" />`
  ).join('');

  dotsEl.querySelectorAll('.aipet-product-cloth-slider-dot').forEach(dot => {
    dot.addEventListener('click', () => clothSliderGoTo(parseInt(dot.dataset.index)));
  });

  clothSliderState = { currentIndex: 0, total: images.length };
  clothSliderGoTo(0);

  const prevBtn = dialog.querySelector('.aipet-product-cloth-slider-prev');
  const nextBtn = dialog.querySelector('.aipet-product-cloth-slider-next');
  if (images.length <= 1) {
    prevBtn && (prevBtn.style.display = 'none');
    nextBtn && (nextBtn.style.display = 'none');
    dotsEl.style.display = 'none';
  } else {
    prevBtn && (prevBtn.style.display = 'flex');
    nextBtn && (nextBtn.style.display = 'flex');
    dotsEl.style.display = 'flex';
  }

  dialog.classList.add('active');
}

function clothSliderGoTo(index) {
  const dialog = document.querySelector('.aipet-product-cloth-dialog');
  if (!dialog) return;
  const track = dialog.querySelector('.aipet-product-cloth-slider-track');
  clothSliderState.currentIndex = index;
  track.style.transform = `translateX(-${index * 100}%)`;
  dialog.querySelectorAll('.aipet-product-cloth-slider-dot').forEach((dot, i) => {
    dot.classList.toggle('active', i === index);
  });
  const prevBtn = dialog.querySelector('.aipet-product-cloth-slider-prev');
  const nextBtn = dialog.querySelector('.aipet-product-cloth-slider-next');
  if (prevBtn) prevBtn.style.opacity = index === 0 ? '0.3' : '1';
  if (nextBtn) nextBtn.style.opacity = index === clothSliderState.total - 1 ? '0.3' : '1';
}

function closeClothDialog() {
  document.querySelector('.aipet-product-cloth-dialog')?.classList.remove('active');
}

document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('.aipet-product-cloth-dialog');
  if (!dialog) return;
  dialog.querySelector('.aipet-product-cloth-slider-prev')?.addEventListener('click', () => {
    if (clothSliderState.currentIndex > 0) clothSliderGoTo(clothSliderState.currentIndex - 1);
  });
  dialog.querySelector('.aipet-product-cloth-slider-next')?.addEventListener('click', () => {
    if (clothSliderState.currentIndex < clothSliderState.total - 1) clothSliderGoTo(clothSliderState.currentIndex + 1);
  });
});
